module.exports = __webpack_public_path__ + "img/816-0b86ad.png";